import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carrot',
  templateUrl: './carrot.component.html',
  styleUrls: ['./carrot.component.css']
})
export class CarrotComponent implements OnInit {
 
 
  stickyFlag:Boolean=false;
  constructor(
  ) { }

  ngOnInit(): void {
    window.addEventListener('scroll', this.scroll, true);
  }

  scroll = () =>{
    let scrolllotation = document.documentElement.scrollTop;
    let positionIntro:any = document.getElementById("intro")?.offsetTop;

    if( !this.stickyFlag &&(scrolllotation >positionIntro-300)){
      this.stickyFlag = true;
    }
    else if( this.stickyFlag &&(scrolllotation <positionIntro -400 )){
      this.stickyFlag = false;
    }
  }
  ngOnDestroy(){
    window.removeEventListener('scroll',this.scroll,true);
  }

}
